import { toast } from 'sonner';

import { graphql } from '@/lib/__generated__';
import {
  Eat_CartFragment,
  Eat_Cart_RemoveItem_Input,
} from '@/lib/__generated__/graphql';
import { apolloClient } from '@/lib/apollo/apollo-client';
import { getAnonId } from '@/lib/utils';

export async function removeItemInCart(
  input: Eat_Cart_RemoveItem_Input,
): Promise<Eat_CartFragment> {
  const response = await apolloClient.mutate({
    mutation: graphql(`
      mutation Eat_Cart_RemoveItem(
        $input: Eat_Cart_RemoveItem_Input!
        $anonId: ID!
      ) {
        Eat_Cart_RemoveItem(input: $input, anonId: $anonId) {
          cart {
            ...Eat_Cart
          }
        }
      }
    `),
    variables: {
      input,
      anonId: getAnonId(),
    },
  });

  const cart = response.data?.Eat_Cart_RemoveItem.cart;

  if (!cart) {
    toast.error('An error occurred', { position: 'top-center' });
    throw new Error(
      response.errors?.map((err) => err.message).join(', ') ??
        'Could not update cart',
    );
  }

  return cart;
}
